<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Création d'une <strong>commission spéciale</strong>  
          </div> 
          <b-row class="form-group">         
            <b-col md="6" v-if="entite_disabled">
              <label for="entite_id">Entité *</label>
              <b-form-select id="entite_id" :plain="true" :options="options" v-model="commission.entite_id" :disabled="entite_disabled == true">
              </b-form-select>
            </b-col>
            <b-col md="6" v-if="entite_visibled">
              <label for="entite_id">Entite *</label>
                <el-select style="display:block;"
                  v-model="commission.entite_id"
                  loading-text="Chargement en cours"
                  no-match-text="Entité non trouvé"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre entité"
                  :remote-method="remoteEntities"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
            <b-col md="6">
              <label for="solde">Valeur (%) *</label>
              <b-form-input type="number" min="0" max="50"  v-model="commission.valeur" placeholder="Valeur de la commission"></b-form-input>
            </b-col>
          </b-row>    
          <b-row class="form-group">         
             <b-col md="6">
              <label for="typeoperation_code">Code Opération *</label>
              <b-form-select id="typeoperation_code" :plain="true" :options="options_code_operation" v-model="commission.typeoperation_code" :disabled="code_disabled == true">
              </b-form-select>
              <!-- <b-form-input type="text" v-model="commission.libelle" placeholder="Libéllé de la commission"></b-form-input> -->
            </b-col>
            <b-col md="3">
              <label for="solde">Date du *</label>
              <b-form-input type="date" v-model="commission.date_du" placeholder=""></b-form-input>
            </b-col>
             <b-col md="3">
              <label for="solde">Date au *</label>
              <b-form-input type="date" v-model="commission.date_au" placeholder=""></b-form-input>
            </b-col>
          </b-row>    
          <b-row class="form-group">         
          
          </b-row>    
          <div slot="footer">
            <span v-if="can('taxe-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      options_code_operation :[],
      commission:{
        entite_id: '',
        typeoperation_code: '',
        valeur: '',
        date_du: '',
        date_au: ''
      },
      typeoperation:[],
      entite_disabled:false,
      entite_visibled:false,
      code_disabled:false,
      
      options4: [],
      value9: [],
      list: [],
      loading: false,
      states: []
    }
  },
  methods:{
      goBack() {
        this.$router.go(-1)
      },
      countDownChanged (dismissCountDown) {
          this.dismissCountDown = dismissCountDown
      },
      showAlert () {
        this.dismissCountDown = this.dismissSecs
      },
      async get_all_entities(){
         if(this.$route.params.entite_id === null || this.$route.params.entite_id === 'null'){
          let serverParams= {
            page:1,
            current_page: 1,
            paginate: 10
          }
          await this.$store.dispatch('entity/get_all_entities',serverParams).then(()=>{
            return this.entities = store.getters['entity/rows'];    
          })
          this.entities.forEach((element)=>{
              this.options.push({
                value:element.id,
                text:element.nom_commercial.toUpperCase(),
              })
          })
          this.entite_visibled = true
          this.entite_disabled = false
        
         }else{
            await this.$store.dispatch('entity/show_entites',this.$route.params.entite_id).then((res)=>{
              return this.entities = res
            })
            this.commission.entite_id = this.$route.params.entite_id
            this.entite_disabled = true
            this.entite_visibled = false
            this.options.push({
              value:this.$route.params.entite_id,
              text:this.entities.nom_commercial.toUpperCase()
            })

         }
      },
      async typeoperations(){
         if(this.$route.params.typeoperation_code === null || this.$route.params.typeoperation_code === 'null'){
          let serverParams= {
            page:1,
            current_page: 1,
            paginate: 10
          }
          await this.$store.dispatch('typeoperation/typeoperations',serverParams).then(()=>{
            return this.type = store.getters['typeoperation/type'];    
          })
          this.type.forEach((element)=>{
              this.options_code_operation.push({
                value:element.code,
                text:element.code.toUpperCase(),
              })
          })
         }else{
            await this.$store.dispatch('typeoperation/typeoperations',this.$route.params.typeoperation_code).then((res)=>{
              return this.type = store.getters['typeoperation/type'].filter(element=>{
                  console.log(' elements',this.$route.params.typeoperation_code)
                  return element.code=== this.$route.params.typeoperation_code
              });
            })
            console.log('le type ',this.type[0])
            this.commission.typeoperation_code = this.$route.params.typeoperation_code
            this.code_disabled = true
            this.options_code_operation.push({
              value:this.$route.params.typeoperation_code,
              text:this.type[0].code.toUpperCase()
            })

         }
      },
      goBack() {
        this.$router.go(-1)
      },
      can(perm){
        return store.getters['auth/can'](perm)
      },
      async post(){     
          this.response = await this.$store.dispatch('commission/post_commissions',this.commission)
          this.showAlert()
          this.reset()
      },
      reset() {
        this.commission.entite_id= '',
        this.commission.typeoperation_code= ''
        this.commission.valeur= ''
        this.commission.date_du= ''
        this.commission.date_au= ''
      },
      remoteEntities(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.options.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options4 = [];
        }
      }
  },
  mounted(){
    this.get_all_entities()
    this.typeoperations()
  }
}
</script>
